t = require('views/internal/teacup-with-helpers')('credit_card')
View = require 'view'

amexTemplate = t.renderable ->
  t.h3 ->
    t.text t.l('amex_title')
  t.p ->
    t.text t.l('amex_info')
  t.img { src: require('images/credit-cards/credit-card-amex.png') }

otherCardsTemplate = t.renderable ->
  t.h3 ->
    t.text t.l('other_cards_title')
  t.p ->
    t.text t.l('other_cards_info')
  t.img { src: require('images/credit-cards/credit-card.png') }

module.exports = class CVVTooltipView extends View
  renderOnce: ->
    switch @options.cardType
      when 'american-express'
        @$el.append(amexTemplate())
      when 'visa', 'master-card', 'discover'
        @$el.append(otherCardsTemplate())
      else
        @$el.append([amexTemplate(), otherCardsTemplate()])
    @


// WEBPACK FOOTER //
// ./app/scripts/views/billing/form-sections/cvv-tooltip-content.coffee